import _typeof from "@babel/runtime/helpers/typeof";
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { defineComponent } from 'vue';
export default defineComponent({
  emits: {
    'update:modelValue': function updateModelValue(value) {
      return true;
    },
    change: function change(value) {
      return true;
    }
  },
  props: {
    multiMode: {
      type: Boolean,
      default: false
    },
    modelValue: [String, Number, Array]
  },
  provide: function provide() {
    return {
      groupContext: this
    };
  },
  data: function data() {
    return {
      sValue: this.multiMode ? [] : undefined
    };
  },
  computed: {
    checkedValue: {
      get: function get() {
        var _this$modelValue;
        return (_this$modelValue = this.modelValue) !== null && _this$modelValue !== void 0 ? _this$modelValue : this.sValue;
      },
      set: function set(val) {
        this.sValue = val;
        this.$emit('update:modelValue', val);
        this.$emit('change', val);
      }
    }
  },
  methods: {
    filterItem: function filterItem(itemList, requireType) {
      var _this = this;
      return itemList.flatMap(function (item) {
        if (_typeof(item.type) === 'symbol') {
          var _item$children;
          return (_item$children = item.children) !== null && _item$children !== void 0 ? _item$children : [];
        }
        return item;
      }).filter(function (item) {
        // @ts-ignore
        var type = item.type;
        var vType = type;
        var isRequire = vType && typeof vType !== 'string' && (vType === null || vType === void 0 ? void 0 : vType.name) === requireType;
        if (!isRequire) {
          var _vType$name;
          var className = _this.className;
          console.error("".concat(className !== null && className !== void 0 ? className : '', " do not support component type '").concat((_vType$name = vType === null || vType === void 0 ? void 0 : vType.name) !== null && _vType$name !== void 0 ? _vType$name : vType, "' for group item"));
        }
        return isRequire;
      });
    }
  }
});